<div class="box">

    <h3 mat-dialog-title>Warning</h3>
    <div mat-dialog-content class="content">
        <!-- <span>{{data.subTitle}}</span> -->
        <span [innerHTML]="data.subTitle"></span>

        <div class="imgWrapper">
            <img src="assets/images/dailog-box/warning.jpg " alt="">
        </div>

        <span class="description" [innerHTML]="data.description"></span>
    </div>
    <div mat-dialog-actions>
        <button *ngIf="data.label1!=null" mat-raised-button class="Save" (click)="negativeAction()"
            (mouseover)="set = true" (mouseout)="set = false">
            {{data.label1==null || data.label1==''? "Go Back" : data.label1}}</button>
        <button *ngIf="data.label2!=null && data.label2 != ''" mat-raised-button class="Cancel"
            (click)="positiveAction()">
            {{data.label2==null ? "Proceed Anyway" : data.label2}}</button>
        <button *ngIf="data.label3!=null && data.label3 != ''" mat-raised-button class="Cancel"
            (click)="extraAction(data.supportTextForlabel3)">{{data.label3}}</button>
        <!-- <button mat-button class="Save" (click)="onNoClick()"> Okay</button> -->
    </div>
</div>
<div class="bg" [class.set]="set"></div>
